import React from "react";
import clsx from "clsx";
import Container from "../views/Container";
import Item from "./Item";

import styles from "./Services.styles";

const Services = ({ elements }) => {
	const css = styles();

	return (
		<div className={clsx(css.contact, "mco-extension-component-services")}>
			<Container
				className={clsx(css.container, "mco-extension-component-services__container")}
			>
				{elements.elements?.map(item => {
					const {id} = item

					return (
						<Item 
							key={id}
							icon={item.textcontent.items.find(element => element.name === "valIcon").text} 
							text={item.textcontent.items.find(element => element.name === "valSteps").text} 
						/>
					)
				})}
			</Container>
		</div>
	);
};

export default Services;
